// @flow

import * as React from 'react';
import {useContext, useState} from 'react';
import {contextStubFunction} from 'docs/util';

export type StepContextType = {
  activeStep: string | null,
  setActiveStep: (string | null) => void,
};

export const StepContext = React.createContext<StepContextType>({
  activeStep: null,
  setActiveStep: contextStubFunction('setActiveStep'),
});

type StepProviderProps = {|
  children: React.Node,
|};

export const StepProvider = (props: StepProviderProps) => {
  const [activeStep, setActiveStep] = useState(null);

  const context = {
    activeStep,
    setActiveStep,
  };

  return (
    <StepContext.Provider value={context}>
      {props.children}
    </StepContext.Provider>
  );
};

export const useStep = () => {
  return useContext(StepContext);
};
